import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';

import { MiscellaneousInformationStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof MiscellaneousInformationStateValues>[] = [
  {
    name: 'didYouMakeAnyEstimatedTaxPayments',
    label: 'Did you make any estimated tax payments?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouBuysellItemsOnlineForMoreThanJustPersonalUse',
    label: 'Did you Buy/Sell items online for more than just personal use?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouBarterWithOrUseBitcoin',
    label: 'Did you barter with or use Bitcoin?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouReceiveAqnyCorrespondanceFormTheIrsOrYourStateTaxAuthority',
    label:
      'Did you receive any correspondence from the IRS or your State tax authority?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'haveYouAlreadySharedThatCorrespondenceWithUs',
        label: 'Have you already shared that correspondence with us?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
        comment: true,
        dependencies: [
          {
            name: 'pleaseUploadACopyOfAllYourCorrespondenceFromIrsOrStateTaxAuthority',
            label:
              'Please upload a copy of all your correspondence from IRS or State Tax Authority.',
            type: 'upload',
            effect: updateKeyInStore(updateKey),

            comment: true,
            predicate: (v) => v === 'no',
          },
        ],
      },
    ],
  },

  {
    name: 'areYouInvolvedInAForeignTrustOrHaveAnyForeignBankAccounts',
    label:
      'Are you involved in a foreign trust or have any foreign bank accounts?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
];

export const validationSchema = Yup.object().shape({});
